import React from 'react';
import AppLayout from '../components-app/AppLayout';
import OverviewList from '../components-static/OverviewList';
import {PageMenu,GenerateSpreadsheet,MobileMenu} from '../components-static/Common';
import u from '../utilities/Utilities';
import {Link} from 'react-router-dom';
import {Spreadsheet} from '../data/Mimetypes';
import styles from '../styles/history-list.scss';

export default class HistoryList extends React.Component{

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[
            {label:"Spreadsheet",mobileLabel:"Generate Spreadsheet",ref:"spreadsheet",image:"/images/page-menu/spreadsheet.png",title:"Generate spreadsheet from selection",enabled:true},
        ],
        spreadsheetOptions:[],
        /************************* Page Specific ************************/
        error:"",
        permissions:{},
        selectMode:false,
    };

    listOptions=[
        {label:"Tag Setting",ref:"macro",enabled:true,type:"list"},
    ];

    scrollAnchor=u.getKey();

    componentDidMount=()=>{
        const permissions = u.getAllPermissions();
        this.setState({permission:permissions});
    };

    onMenuOptionClicked=(ref,show,mobileNav)=>{
        if(mobileNav){
            const toggle = (this.mobileSelect != ref);
            this.setState({selectMode:((ref=="spreadsheet" || ref=="delete") && toggle)});
            this.mobileSelect= ((toggle) ? ref : null);
            for(var i=0; i<mobileNav.length; i++){
                const r = mobileNav[i].ref;
                const show = (r == ref);

                if(show){
                    if(mobileNav[i].onClick){
                        mobileNav[i].onClick();
                    }
                    else if(mobileNav[i].type == "list"){
                        this.refs['overview'].triggerListOptions(r,toggle);
                    }
                    else{
                        this.refs[r].show(toggle);
                    }
                }
                else{
                    if(mobileNav[i].onClick) {

                    }
                    else if(mobileNav[i].type == "list"){
                        this.refs['overview'].triggerListOptions(r,false);
                    }
                    else{
                        this.refs[r].show(false);
                    }
                }
            }
        }
        else{
            this.setState({selectMode:((ref=="spreadsheet" || ref=="delete") && show)});
            this.refs[ref].show(show);
        }
    }

    onToggleForm=(ref,show)=>{
        this.refs['menu'].toggleForm(ref,show);
        this.mobileSelect=(show) ? ref : null;
    }

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    }

    onRefreshList=()=>{
        this.refs['overview'].onRefreshList();
    }

    onContentGrabbed=(content)=>{
        this.setState({spreadsheetOptions:content.spreadsheetOptions});
    }

    /************************************* Page Specific **************************************/

    render(){
        const mobileMenu = this.state.pageMenuButtons.concat(this.listOptions);
        return (
            <AppLayout title="History" requiredPermission="combined" requiredField="history" url="/history-list">
                <div className="page-error-container">
                    <div className="page-error">{this.state.error}</div>
                </div>
                <PageMenu ref="menu" id={this.scrollAnchor} title={"History"} buttons={this.state.pageMenuButtons} onMenuOptionClicked={this.onMenuOptionClicked}>
                    <GenerateSpreadsheet scrollAnchor={this.scrollAnchor} ref="spreadsheet" url="/api/generate-history-spreadsheet" options={this.state.spreadsheetOptions} reference="spreadsheet" selected={this.state.selected} onToggleForm={this.onToggleForm}/>
                </PageMenu>
                <OverviewList ref="overview" selectMode={this.state.selectMode} url="/api/get-all-history" label="history-list" numRows={20} orderByField="dateTime" onSelectChange={this.onSelectChange} orderByType="descending" onContentGrabbed={this.onContentGrabbed} disableChild={true} timeMode={true} timeModeDateField="dateTime" timeModeField="event">
                    {
                        (content,index,onChange)=>{
                            return (
                                <div>
                                    <span title={"@staff("+content.staffName+")"}>{(content.staffID) ? <Link to={"/staff/" + content.staffID} id={"staffID-" + content.staffID} onClick={u.setLinkContext} onContextMenu={u.setLinkContext}>{content.staffName}</Link> : content.staffName}</span>
                                    <span title={"@action("+content.action+")"}> {content.action} </span>
                                    <span title={"@target("+content.targetName+")"}> {(content.targetLink==null) ? content.targetName : <Link to={content.targetLink} id={content.targetLinkID} onClick={u.setLinkContext} onContextMenu={u.setLinkContext}>{content.targetName}</Link>}</span>
                                    <span title={"@field("+content.targetField+")"}>{(content.targetField==null) ? "" : " (" + content.targetField + ")"}</span>
                                    <span title={"@from("+content.from+")"}>{(content.from == null) ? "" : ((content.fromLink == null) ? " from "+content.from : <span> from <Link to={content.fromLink} id={content.fromLinkID} onClick={u.setLinkContext} onContextMenu={u.setLinkContext}>{content.from}</Link></span>)}</span>
                                    <span title={"@to("+content.to+")"}>{(content.to == null) ? "" : ((content.toLink == null) ? " to "+content.to : <span> to <Link to={content.toLink} id={content.toLinkID} onClick={u.setLinkContext} onContextMenu={u.setLinkContext}>{content.to}</Link></span>)}</span>
                                </div>
                            )
                        }
                    }
                </OverviewList>
                <MobileMenu content={mobileMenu} onClick={this.onMenuOptionClicked}/>
            </AppLayout>
        )
    }
}